// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/add_inventory.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InventoryItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.AddInventoryRequest
 */
export class AddInventoryRequest extends Message<AddInventoryRequest> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.InventoryItem items = 1;
   */
  items: InventoryItem[] = [];

  /**
   * @generated from field: string stock_point_id = 2;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<AddInventoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AddInventoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: InventoryItem, repeated: true },
    { no: 2, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddInventoryRequest {
    return new AddInventoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddInventoryRequest {
    return new AddInventoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddInventoryRequest {
    return new AddInventoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddInventoryRequest | PlainMessage<AddInventoryRequest> | undefined, b: AddInventoryRequest | PlainMessage<AddInventoryRequest> | undefined): boolean {
    return proto3.util.equals(AddInventoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AddInventoryResponse
 */
export class AddInventoryResponse extends Message<AddInventoryResponse> {
  constructor(data?: PartialMessage<AddInventoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AddInventoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddInventoryResponse {
    return new AddInventoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddInventoryResponse {
    return new AddInventoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddInventoryResponse {
    return new AddInventoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddInventoryResponse | PlainMessage<AddInventoryResponse> | undefined, b: AddInventoryResponse | PlainMessage<AddInventoryResponse> | undefined): boolean {
    return proto3.util.equals(AddInventoryResponse, a, b);
  }
}

